/** Monday on or before ymd (local noon parse). */
export function mondayOfWeekYmd(ymd) {
  const d = new Date(`${String(ymd).slice(0, 10)}T12:00:00`);
  const day = d.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  d.setDate(d.getDate() + diff);
  return d.toISOString().slice(0, 10);
}

/** Sunday ending the week that starts on weekStartYmd. */
export function endOfWeekYmd(weekStartYmd) {
  const d = new Date(`${String(weekStartYmd).slice(0, 10)}T12:00:00`);
  d.setDate(d.getDate() + 6);
  return d.toISOString().slice(0, 10);
}

/** Index of the week row in boundsWeeks that contains ymd. */
export function weekIndexForYmd(ymd, boundsWeeks) {
  if (!boundsWeeks?.length) return 0;
  const mon = mondayOfWeekYmd(ymd);
  const exact = boundsWeeks.indexOf(mon);
  if (exact >= 0) return exact;
  for (let i = boundsWeeks.length - 1; i >= 0; i -= 1) {
    if (boundsWeeks[i] <= mon) return i;
  }
  return 0;
}

export function formatWeekSpanLabel(startYmd, endYmd) {
  return `${String(startYmd).slice(5)} → ${String(endYmd).slice(5)}`;
}

/** Local calendar date as YYYY-MM-DD. */
export function todayYmdLocal() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** True when weekStartYmd is the Monday of the current local calendar week. */
export function isCurrentCalendarWeek(weekStartYmd) {
  return weekStartYmd === mondayOfWeekYmd(todayYmdLocal());
}
